import SuperTokens from "supertokens-web-js";
import Session from "supertokens-web-js/recipe/session";
import EmailPassword from "supertokens-web-js/recipe/emailpassword";
import {SuperTokensApiEndpoint, SuperTokensCookieDomain} from "@/beepallet.consts";
import EmailVerification from "supertokens-web-js/recipe/emailverification";

export function initSuperTokens() {
    SuperTokens.init({
        appInfo: {
            appName: "BeePallet",
            apiDomain: SuperTokensApiEndpoint
        },
        recipeList: [
            EmailVerification.init(),
            EmailPassword.init({}),
            Session.init(
                {
                    sessionTokenFrontendDomain: SuperTokensCookieDomain,
                    sessionTokenBackendDomain: SuperTokensCookieDomain,
                    autoAddCredentials: true,
                    tokenTransferMethod: 'header'
                }
            ),
        ],
    });
}